import {
    commitMutation,
    graphql
} from 'react-relay'
import environment from '../../Environment'


const mutation = graphql`
    mutation CreateTaskStatusMutation($data: TaskStatusCreateInput!) {
        createTaskStatus(data:$data) {
            id
      }
    }
  `

export default (data, callback) => {
    const variables = {
        data
    }

    commitMutation(
        environment,
        {
            mutation,
            variables,
            onCompleted: (response) => {
                callback({ status: 'OK', pyload: response.createTaskStatus })
            },
            onError: err => callback({ status: 'KO', message: err })
        },
    )
}